import React from 'react';

interface SpinningLoaderProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'white' | 'gray' | 'custom';
  thickness?: 'thin' | 'normal' | 'thick';
  className?: string;
}

const SpinningLoader: React.FC<SpinningLoaderProps> = ({
  size = 'medium',
  color = 'white',
  thickness = 'normal',
  className = '',
}) => {
  // Define size values based on prop
  const sizeMap = {
    small: 'h-4 w-4',
    medium: 'h-6 w-6',
    large: 'h-8 w-8',
  };

  const colorMap = {
    primary: 'border-primary',
    secondary: 'border-secondary',
    white: 'border-white',
    gray: 'border-gray-300',
    custom: '', // To allow custom color from className
  };

  const thicknessMap = {
    thin: 'border',
    normal: 'border-2',
    thick: 'border-4',
  };

  return (
    <div
      className={`${sizeMap[size]} ${thicknessMap[thickness]} border-t-transparent ${colorMap[color]} rounded-full animate-spin ${className}`}
      aria-label='Loading'
    />
  );
};

export default SpinningLoader;
